// Mock data for PropertySellEasy website

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Phoenix, AZ",
    rating: 5,
    text: "Got my offer in 5 minutes and closed in 10 days. No repairs, no showings, no stress. PropertySellEasy.com saved me months of headaches.",
    image: "https://images.unsplash.com/photo-1494790108755-2616b60b513f?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Tampa, FL",
    rating: 5,
    text: "After inheriting my parents' house, I needed a quick sale. Their AI offer was fair and the process was incredibly smooth from start to finish.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Dallas, TX",
    rating: 5,
    text: "Facing foreclosure, I thought I was out of options. PropertySellEasy.com's cash offer helped me avoid bankruptcy and move on with my life.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Data Collection",
    description: "Enter your property address with as little or as much info you'd like. We pull current estimated values from millions of proprietary data points across multiple platforms.",
    icon: "Home"
  },
  {
    step: 2,
    title: "AI Analysis & Site Average",
    description: "Our system analyzes data from multiple sources and market conditions to create accurate baseline values using advanced algorithms.",
    icon: "Brain"
  },
  {
    step: 3,
    title: "Market Analysis",
    description: "AI evaluates local market conditions including days on market, price trends, and inventory levels using real-time market-specific multipliers.",
    icon: "FileCheck"
  },
  {
    step: 4,
    title: "Offer Generation",
    description: "Final cash offer is automatically calculated and delivered to your inbox or via follow-up call with one of our Acquisition Partners.",
    icon: "Handshake"
  }
];

export const valueProps = [
  {
    title: "AI-Powered Fair Offers",
    description: "Our proprietary algorithm analyzes millions of data points from cash buyer transactions within minutes of your property over the last 12-18 months.",
    icon: "Brain",
    color: "blue"
  },
  {
    title: "Expert Network",
    description: "Work with our trusted network of property managers, investors, attorneys, probate specialists, and private money funds across all operating states.",
    icon: "Users",
    color: "green"
  },
  {
    title: "Quick Closing",
    description: "Close in 2-4 weeks on average. Skip the 60-90+ day traditional timeline and get your cash when you need it most.",
    icon: "Clock",
    color: "blue"
  },
  {
    title: "Creative Financing",
    description: "Become a lender instead of just a seller. Earn monthly returns while reducing your tax burden through our innovative financing options.",
    icon: "TrendingUp",
    color: "green"
  },
  {
    title: "Sell As-Is Condition",
    description: "No need to fix leaky roofs, update kitchens, or stage rooms. We buy properties in any condition nationwide.",
    icon: "Shield",
    color: "blue"
  },
  {
    title: "Zero Hidden Fees",
    description: "No realtor commissions, inspection fees, or surprise closing costs. The offer you see is exactly what you get.",
    icon: "Zap",
    color: "green"
  }
];

export const aboutStory = {
  founder: "Winston",
  education: "Michigan State University Graduate",
  background: "Former Dell Corporate Sales Professional",
  location: "Detroit, MI native, now serving nationwide from Austin, TX",
  family: "Married to his wife from Fort Worth, TX, proud father of a 2-year-old son",
  motivation: "After being laid off multiple times in 10 years, Winston found his passion in real estate and helping families through difficult property situations.",
  mission: "To provide homeowners with a stress-free, profitable alternative to traditional real estate sales."
};

export const offerCalculatorData = {
  states: [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", 
    "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", 
    "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", 
    "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", 
    "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", 
    "New Hampshire", "New Jersey", "New Mexico", "New York", 
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", 
    "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", 
    "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", 
    "West Virginia", "Wisconsin", "Wyoming"
  ],
  propertyTypes: [
    "Single Family Home",
    "Townhouse",
    "Condo",
    "Multi-Family (2-4 units)",
    "Mobile Home",
    "Vacant Land",
    "Commercial Property"
  ],
  conditions: [
    "Excellent",
    "Good",
    "Fair",
    "Needs Minor Repairs",
    "Needs Major Repairs",
    "Needs Complete Renovation"
  ],
  timelines: [
    "ASAP",
    "Within 2 weeks",
    "30 days",
    "60 days",
    "90 days+"
  ],
  reasonsForSelling: [
    "Tired Landlord",
    "Retiring",
    "Too many Repairs",
    "Job Loss",
    "Preforeclosure",
    "Probate",
    "Bad Tenants",
    "Need the Cash",
    "Other"
  ]
};

export const contactInfo = {
  phone: "1-888-334-3524",
  email: "info@100doorcapital.com",
  address: "5900 Balcones Dr Ste 100, Austin, TX 78731",
  hours: "Monday - Sunday: 8 AM - 5 PM CDT"
};

export const operatingStates = [
  "CA", "MI", "OH", "AR", "TX", "GA", "FL", "TN", "AL", "AZ", "MO", "HI", "MD", "ID", "IN", "CO", "NV"
];